import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";

const Certifications = ({ newdata, setNewdata }) => {
  const certifications = newdata.certification || [];

  // Handle input changes
  const handelvalues = (e, index) => {
    const { name, value } = e.target;
    const updated = [...certifications];
    updated[index] = { ...updated[index], [name]: value };
    setNewdata((prev) => ({ ...prev, certification: updated }));
  };

  // Add new row
  const AddmoreFields = () => {
    setNewdata((prev) => ({
      ...prev,
      certification: [
        ...certifications,
        {
          nameofcertificate: "",
          institution: "",
          issuingauthority: "",
          effectivedate: "",
          expirationdate: "",
        },
      ],
    }));
  };

  // Remove a row
  const handleRemoveClick = (index) => {
    setNewdata((prev) => ({
      ...prev,
      certification: certifications.filter((_, i) => i !== index),
    }));
  };

  return (
    <div className="px-2">
      {certifications.map((cert, index) => (
        <div key={index} className="mb-3">
          <Row className="mb-2">
            <Col md={4}>
              <Form.Label className="custm-lble">Name of Certification</Form.Label>
              <Form.Control
                type="text"
                name="nameofcertificate"
                placeholder="Name of Certification"
                value={cert?.nameofcertificate || ""}
                onChange={(e) => handelvalues(e, index)}
              />
            </Col>
            <Col md={4}>
              <Form.Label className="custm-lble">Institution</Form.Label>
              <Form.Control
                type="text"
                name="institution"
                placeholder="Institution"
                value={cert?.institution || ""}
                onChange={(e) => handelvalues(e, index)}
              />
            </Col>
            <Col md={4}>
              <Form.Label className="custm-lble">Issuing Authority</Form.Label>
              <Form.Control
                type="text"
                name="issuingauthority"
                placeholder="Issuing Authority"
                value={cert?.issuingauthority || ""}
                onChange={(e) => handelvalues(e, index)}
              />
            </Col>
          </Row>

          <Row className="mb-2">
            <Col md={4}>
              <Form.Label className="custm-lble">Effective Date</Form.Label>
              <Form.Control
                type="text"
                name="effectivedate"
                placeholder="Effective Date"
                value={cert?.effectivedate || ""}
                onChange={(e) => handelvalues(e, index)}
              />
            </Col>
            <Col md={4}>
              <Form.Label className="custm-lble">Expiration Date</Form.Label>
              <Form.Control
                type="text"
                name="expirationdate"
                placeholder="Expiration Date"
                value={cert?.expirationdate || ""}
                onChange={(e) => handelvalues(e, index)}
              />
            </Col>
          </Row>

          {index !== 0 && (
            <div className="d-flex justify-content-end mb-2">
              <DeleteIcon
                className="color-red cursor_P"
                onClick={() => handleRemoveClick(index)}
              />
            </div>
          )}

          <hr className="mb-2" />
        </div>
      ))}

      <div className="mb-3" onClick={AddmoreFields}>
        <p className="color-text cursor_P">
          <AddCircleIcon style={{ fontSize: "large" }} /> Add More
        </p>
      </div>
    </div>
  );
};

export default Certifications;
